import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Box = styled.div<{ $isRow?: boolean; $hasBottomMargin?: boolean }>`
  padding-bottom: ${({ $hasBottomMargin }) =>
    $hasBottomMargin ? '15px' : '0'};

  ${({ $isRow }) =>
    $isRow &&
    css`
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
      gap: 10px;
    `}
`;

export const Title = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.secondary.labels};
  margin-bottom: 10px;
`;
